import React from 'react';
import {connect} from 'react-redux';
import Loading from 'components/shared-components/Loading';
import PageHeader from 'components/layout-components/PageHeader';
import Footer from 'components/layout-components/Footer';
import DocumentationViews from 'views/documentation-views';
import {Grid, Layout} from 'antd';

import navigationConfig from 'configs/NavigationConfig';
import {DIR_LTR, DIR_RTL, NAV_TYPE_TOP, SIDE_NAV_WIDTH,} from 'constants/ThemeConstant';
import utils from 'utils';
import {useThemeSwitcher} from 'react-css-theme-switcher';
import FullscreenLoading from 'components/shared-components/FullscreenLoading';
import DocumentationMobileNav from 'components/layout-components/DocumentationMobileNav';
import DocumentationSideNav from 'components/layout-components/DocumentationSideNav';
import DocumentationHeaderNav from 'components/layout-components/DocumentationHeaderNav';

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const DocumentationLayout = ({
  navCollapsed,
  navType,
  location,
  direction,
}) => {
  const currentRouteInfo = utils.getRouteInfo(
    navigationConfig,
    location.pathname
  );
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes('lg');
  const isNavTop = navType === NAV_TYPE_TOP;
  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0;
    }
    return navCollapsed ? 0 : SIDE_NAV_WIDTH;
  };

  const { status } = useThemeSwitcher();

  if (status === 'loading') {
    return <Loading cover="page" />;
  }

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };

  return (
    <>
      <Layout>
        <Layout className="app-container">
          {!isMobile ? (
            <DocumentationSideNav
              localization={false}
              routeInfo={currentRouteInfo}
            />
          ) : null}

          <Layout className="app-layout" style={getLayoutDirectionGutter()}>
            <DocumentationHeaderNav isMobile={isMobile} />
            <div className={`app-content ${isNavTop ? 'layout-top-nav' : ''}`}>
              <PageHeader
                display={currentRouteInfo?.breadcrumb}
                title={currentRouteInfo?.title}
              />
              <Content>
                <DocumentationViews />
              </Content>
            </div>
            <Footer />
          </Layout>
        </Layout>
        {isMobile && <DocumentationMobileNav />}
      </Layout>
      <FullscreenLoading />
    </>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;
  return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(DocumentationLayout));
